<template>
  <div id="creative-tool">
    <vs-row vs-type="flex">
      <vx-card class="card-wrap">
        <vs-col v-for="(dr, index) of list" :key="index" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
          <div class="card-content-wrap">
            <img class="card-img" :src="dr.thumbUrl" alt="" @click="openToolsPage(dr.webUrl, dr.type)">
            <p>{{dr.name}}</p>
            <p><span class="tip-span">({{dr.tip}})</span></p>
          </div>
        </vs-col>
      </vx-card>
    </vs-row>
  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      list: [
        {
          "id":1,
          "name":"海码编辑器",
          "thumbUrl":"http://haimaketang.oss-cn-shenzhen.aliyuncs.com/49a66202009151033167455.png",
          "tip":"图形化编程","webUrl":"https://hainanai.net/scratch","type":"scratch"
        },
        {
          "id":2
          ,"name":"MagicBlock",
          "thumbUrl":"http://haimaketang.oss-cn-shenzhen.aliyuncs.com/3d4cb202103101522092600.png",
          "tip":"硬件编程","webUrl":"https://hainanai.net/program/list","type":""
        }
      ]
    }
  },
  created() {},
  mounted() {
    
  },
  computed: {
    
  },
  methods: {
    openToolsPage(webUrl, type) {
      window.open(webUrl, type);
    }
  },
}
</script>

<style lang="scss">
#creative-tool{
  text-align: center;
  .card-wrap{
    padding: 1rem;
    .card-content-wrap{
      .card-img{
        margin: 10px auto;
        cursor: pointer;
        max-height: 12rem;
      }
      p{
        margin-bottom: 0.8rem;
      }
      .tip-span{
        color: rgb(185, 183, 183);
      }
    }
  }
}
</style>
